
  export let env = {
    production: false,
    whiteLabel: 'TRACKIMO' || 'TRACKIMO',
    baseApiUrl: 'api' || 'api',
    baseRedirectUrl: 'https://dev.trackimo.com',
    googleMapApiKey: 'AIzaSyCbL8rgOtmuwHr7038PmPSeU7kpKKBL8vo'
  };
